/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useRef, useState } from 'react';
import { Box } from 'native-base';
import _ReactPlayer, { ReactPlayerProps } from 'react-player';
import VisibilitySensor from 'react-visibility-sensor';
import { Stashboard, StashboardMedia, useAppSettings, useSpringBigStore } from '@springbig/shared';
import Image from '~/shared/Image';
import { useSendEvent } from '@springbig/shared';

const ReactPlayer = _ReactPlayer as unknown as React.FC<ReactPlayerProps>;

export const CarouselCard = ({ item, index, stashboard, setImgHeight, currentIndex }: {item: StashboardMedia, index: number, stashboard: Stashboard, setImgHeight: (height: number) => void, currentIndex: number}) => {

    const { fontFamily } = useAppSettings();
    const [isVisible, setIsVisible] = useState(false);
    const { merchant } = useSpringBigStore();
    const { mutate: sendEvent } = useSendEvent();

    if (stashboard?.full_image_content) {

        const imgRef = useRef(null);
        const [imgWidth, setImgWidth] = useState(0);

        useEffect(() => {

            const handleResize = () => {

                if (imgRef.current) {
                    setImgWidth(imgRef.current.clientWidth);
                    setImgHeight(imgRef.current.clientHeight);
                }
            };

            if (imgRef.current) {
                setImgWidth(imgRef.current.clientWidth);
                setImgHeight(imgRef.current.clientHeight);
            }

            window.addEventListener('resize', handleResize);
        }, [imgRef.current]);

        const handleImageLoad = () => {

            if (imgRef.current) {
                setImgWidth(imgRef.current.clientWidth);
                setImgHeight(imgRef.current.clientHeight);
            }
        };

        return <div key={index} style={{ float: 'left', position: 'relative', width: '100%' }}>

            <img ref={imgRef} src={item.result_url} width={'100%'} onLoad={handleImageLoad} loading='lazy' />
            {stashboard.full_image_content.map((full_image_content, index0) =>

                full_image_content.buttons.map((button, index1) => {

                    const handleClick = () => {

                        window.open(button.target_url);

                        if (merchant?.enhanced_reporting_enabled) {
                            sendEvent({
                                event: 'click',
                                sbk: stashboard._key,
                                event_owner_id: button.id,
                                event_owner_type: 'StashboardImageButton',
                                source: 'wallet',
                            });
                        }
                    };

                    if (index0 !== index) {
                        return <></>;
                    }

                    return (
                        <button
                            key={`${index0}, ${index1}`}
                            style={{
                                position: 'absolute',
                                width: `${button.width}%`,
                                height: `${imgWidth * button.height / 100}px`,
                                top: `${imgWidth * button.y / 100}px`,
                                left: `${button.x}%`,
                                backgroundColor: button.style === 'visible' ? button.background_color : 'transparent',
                                borderRadius: button.border_radius,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                padding: 0,
                                margin: 0,
                                boxShadow: 'none',
                                color: button.text_color,
                                fontSize: `${(button.font_size * imgWidth) / 100}px`,
                                overflow: 'hidden',
                                border: button.background_color ?? `1px solid ${button.background_color}`,
                                fontFamily: button.text_font ?? `${button.text_font}, ${fontFamily}`,
                            }}
                            onClick={handleClick}
                        >
                            {button.text}
                        </button>
                    );
                }
                ))}
        </div>;
    }

    if (item?.media_type === 'video') {

        return (
            <VisibilitySensor onChange={(visibility) => visibility && setIsVisible(visibility && currentIndex === index)}>
                <Box key={index} w={'100%'} height={'96'} zIndex={99999}>
                    <ReactPlayer url={item.result_url} width={'100%'} height={'100%'} playing={isVisible} loop muted controls />
                </Box>
            </VisibilitySensor>
        );
    }

    if (item?.media_type === 'image') {

        const imgRef = useRef(null);

        useEffect(() => {

            const handleResize = () => {

                if (imgRef.current) {
                    setImgHeight(imgRef.current.clientHeight);
                }
            };

            if (imgRef.current) {
                setImgHeight(imgRef.current.clientHeight);
            }

            window.addEventListener('resize', handleResize);
        }, [imgRef.current]);

        const handleImageLoad = () => {

            if (imgRef.current) {
                setImgHeight(imgRef.current.clientHeight);
            }
        };

        return <img key={index} ref={imgRef} src={item.result_url} width={'100%'} onLoad={handleImageLoad} loading='lazy' />;
    }

    return (
        <Box key={index} w={'100%'} height={96} zIndex={99999}>
            <Image
                w={'100%'}
                h={'96'}
                uri={'https://www.foot.com/wp-content/uploads/2017/06/placeholder-square.jpg'} // TODO: wtf is this?
            />
        </Box>
    );
};
